import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting/customer/orders-additional-costs";

export default {
  getAdditionalCost(id) {
    return Repository.get(`${resource}/${id}`)
  },
  getAdditionalCostList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createAdditionalCost(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteAdditionalCost(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateAdditionalCost(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
